var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('fab-icon-card',_vm._b({},'fab-icon-card',_vm.data,false),[_c('div',[_vm._v("Men's Shoe "),_c('span',{staticClass:"pink--text"},[_vm._v(" $189.99")])]),_c('div',[_c('b',[_vm._v("Size")]),_vm._v(": 6 US")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }